<template>
  <w-sliding-popup ref="slidingPopup" type="setting" title="경보 설정 수정" @close="closePopup" width="550px">
    <el-form slot="content" :ref="formName" :model="warningInfo" :rules="rules" label-position="top">
      <el-row>
        <el-col :span="24">
          <el-form-item label="경보 코드" prop="warningCode">
            <el-input :disabled="true" v-model="warningInfo.warningCode" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row >
        <el-col :span="24">
          <el-form-item label="설명" prop="warningDesc">
            <el-input :disabled="true" v-model="warningInfo.warningDesc" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="적용 여부" prop="applyFlag">
            <el-switch v-model="warningInfo.applyFlag" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="이벤트 레벨" prop="eventlevelId">
            <el-select v-model="warningInfo.eventlevelId" style="width:100%">
              <el-option v-for="item in eventlevelList" :key="item.eventlevelId" :label="item.eventlevelName" :value="item.eventlevelId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="임계치" prop="threshold">
            <el-input-number style="width:100%" controls-position="right" v-model="warningInfo.threshold" placeholder="입력해 주세요." :min="0"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="측정시간" prop="eventJudgeTime">
            <el-input-number style="width:100%" controls-position="right" v-model="warningInfo.eventJudgeTime" placeholder="입력해 주세요." :min="0"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="기준횟수" prop="eventJudgeCount">
            <el-input-number style="width:100%" controls-position="right" v-model="warningInfo.eventJudgeCount" placeholder="입력해 주세요." :min="0"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="이벤트 해지시간" prop="normalizationTime">
            <el-input-number style="width:100%" controls-position="right" v-model="warningInfo.normalizationTime" placeholder="입력해 주세요." :min="0"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button size="large" type="solid" @click="saveWarningSet">저장</el-button>
      <el-button size="large" @click="closePopup">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { isNil } from 'lodash';
import msgUtil from '@/utils/message';
import ApmSettingAPI from '@/api/settings/apm/apm-setting';

export default {
  name: 'WWarningSetPopup',
  components: {
  },
  props: {
    editRow: Object,
  },
  watch: {
    editRow: {
      handler() {
        if (!isNil(this.editRow)) {
          this.warningInfo = this.editRow;
        }
      },
      immediate: true,
    },
  },
  computed: mapGetters(['eventlevelList']),
  data() {
    return {
      formName: 'warningForm',
      warningInfo: {
        delay: null,
        domainId: null,
        eventJudgeCount: null,
        eventJudgeTime: null,
        eventlevelId: null,
        normalizationTime: null,
        applyFlag: null,
        threshold: null,
        warningCode: null,
        warningDesc: null,
        warningType: null,
      },
      rules: {
        threshold: { type: 'number', required: true, trigger: 'blur', message: '숫자값을 입력해주세요' },
        eventJudgeTime: { type: 'number', required: true, trigger: 'blur', message: '숫자값을 입력해주세요' },
        eventJudgeCount: { type: 'number', required: true, trigger: 'blur', message: '숫자값을 입력해주세요' },
        normalizationTime: { type: 'number', required: true, trigger: 'blur', message: '숫자값을 입력해주세요' },
      },
    };
  },
  methods: {
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    closePopup() {
      this.$refs[this.formName].resetFields();
      this.$refs.slidingPopup.visible = false;
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$emit('open');
    },
    saveWarningSet() {
      const params = {
        ...this.warningInfo,
        warningType: this.editRow.type,
      };
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          ApmSettingAPI.setWarningSetInfo(params).then((response) => {
            if (response.data.success) {
              this.$emit('reload');
              this.closePopup();
            }
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '경보', response.data.success));
          }).catch(() => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '경보', false));
          });
        } else {
          this.$message(msgUtil.getCustomMsgData('입력사항을 확인해주세요.'));
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/apm/WarningSettings/popup/WarningSetPopup.vue